
import React, { useState, useEffect } from 'react';
import apiUrl from '../../../Apiurl';
import { useAuth0 } from '@auth0/auth0-react';

function GaranziaVoceCliccabile({ setGaranzia, idGaranzia, datoDisplay }) {

    const { user, /* isAuthenticated,  */getAccessTokenSilently } = useAuth0();
    const [token, setToken] = useState("");


    useEffect(() => {
        const getUserMetadata = async () => {
          try {
            const accessToken = await getAccessTokenSilently();
            setToken(accessToken);
          } catch (e) {
            console.log(e.message);
          }
        };
        getUserMetadata();
      }, [getAccessTokenSilently, user?.sub]);
    
    
      const click = (e) => {
        if (!token) {
          console.warn("sto aspettando un token")
          return;
        }
        
          fetch(apiUrl + "/logistica/garanzia/ricGaranzia/"+idGaranzia, { headers: { Authorization: "Bearer " + token } })
          .then(resp => resp.json())
          .then(data => setGaranzia(data || false))
          .then(e.preventDefault())
        
      }
 

    return (

        <div className='pointer' onClick={click}>{datoDisplay}
        </div>

    )
}



export default GaranziaVoceCliccabile;



